import React from 'react';
import BusComponent from '../BusComponent';
import Loader from '../Loader';
import UserUploadItem from './UserUploadItem';
import {injectIntl} from "react-intl";

class MyUploads extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.bindGluBusEvents({
            USER_DATA: this.onDataRetrieved,
            USER_LAYER_DELETE_REQUEST: this.onDeleteUserLayer,
        });

        this.state = {
            isLoading: true,
            userUploadedData: [],
        };
    }

    componentDidMount() {
        this.emit('RETRIEVE_USER_DATA');
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onDataRetrieved = userUploadedData => {
        this.setState({
            userUploadedData,
            isLoading: false,
        });
    };

    onDeleteUserLayer = e => {
        if (!e.userData) return;

        this.setState(prev => ({
            userUploadedData: prev.userUploadedData.filter(d => d.title !== e.userLayerTitle),
        }));
    };

    render() {
        const { intl, mapInstanceId } = this.props;
        const { isLoading, userUploadedData } = this.state;
        if ((!isLoading && !userUploadedData.length) || !userUploadedData.find(it => it))
            return null;

        return (
            <div className="user-data-uploads flex-it grow column">
                <div className="user-data-uploads__title">
                    {intl.formatMessage({ id: "dataBrowser.previousUploads" })}
                </div>
                {isLoading &&
                    <Loader text={intl.formatMessage({ id: "dataBrowser.loadingUserDataLayers" })}/>
                }
                {!isLoading && (
                    <div className="user-data-uploads__list vertical-scrollbar">
                        {userUploadedData.map(ud => (
                            <UserUploadItem
                                key={ud.id}
                                mapInstanceId={mapInstanceId}
                                userData={ud}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default injectIntl(MyUploads);
